export default class BodyController {

}
